import { render, staticRenderFns } from "./DuplicatedInfo.vue?vue&type=template&id=65b94a7c&"
import script from "./DuplicatedInfo.vue?vue&type=script&lang=js&"
export * from "./DuplicatedInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports